import React from "react";

const Terms = () => {
  return (
    <div style={styles.wrapper}>
      <h1 style={styles.title}>Terms & Conditions</h1>

      <p style={styles.text}>
        Welcome to <strong>JobKickstart</strong>. By accessing this website, you
        agree to comply with and be bound by the following terms.
      </p>

      <h2 style={styles.heading}>Use of Website</h2>
      <p style={styles.text}>
        You agree to use this website only for lawful purposes. You must not use
        this website in any way that may damage the site or affect user access.
      </p>

      <h2 style={styles.heading}>Content Accuracy</h2>
      <p style={styles.text}>
        We do our best to provide accurate job information, but we do not guarantee
        completeness or reliability. Users should verify details independently.
      </p>

      <h2 style={styles.heading}>Intellectual Property</h2>
      <p style={styles.text}>
        All content on this website, including text, graphics, and design, is the
        property of JobKickstart and protected by copyright laws.
      </p>

      <h2 style={styles.heading}>User Responsibility</h2>
      <p style={styles.text}>
        You are responsible for ensuring that any information or services available
        meet your specific requirements.
      </p>

      <h2 style={styles.heading}>Limitation of Liability</h2>
      <p style={styles.text}>
        We are not liable for any loss or damage arising from the use of this website.
      </p>

      <h2 style={styles.heading}>Changes to Terms</h2>
      <p style={styles.text}>
        We may update these terms at any time. Continued use of the site means you
        accept those changes.
      </p>

      <h2 style={styles.heading}>Contact Us</h2>
      <p style={styles.text}>
        For any questions regarding these terms:
        <br />
        📩 jobkickstart.online@gmail.com
      </p>
    </div>
  );
};

const styles = {
  wrapper: {
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "auto",
    marginTop:'50px',
    fontFamily: "Arial",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "36px",
    fontWeight: "800",
    marginBottom: "20px",
  },
  heading: {
    fontSize: "22px",
    marginTop: "25px",
    fontWeight: "700",
  },
  text: {
    fontSize: "16px",
    color: "#444",
  },
};

export default Terms;